import { saveContent } from '@actions/rapidql.actions';
import { createReducer, on } from '@ngrx/store';

export const rapidqlKey = 'rapidql';

export interface RapidqlState {
  filters: any;
}

const initialState = {
  filters: null
};

const reducer = createReducer(
  initialState,
  on(saveContent, (state, { filters }) => ({ ...state, filters }))
);

export function rapidqlReducer(state = initialState, action) {
  return reducer(state, action);
}
